import { ProfileModel } from '../../profile/model/profile.model';
import { ModuleModel } from '../../module.model.interface';

export enum ResourceType {
  None,
  DataEntry,
  Organization,
  Assignment,
  Profile,
  ModificationRequest,
  ClarificationRequest,
  Batch,
  Case,
  Bulletin,
  OfficialAct,
  Universal,

  External
}

export class ResourceTypeDetail implements ModuleModel {
  public discriminator = 'ResourceTypeDetail';
  public id: string;
  public name: string;
  public typename: string;

  constructor(options?: {
    id: string,
    name: string,
    typename: string
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
      this.typename = options.typename;
    }
  }
}

export const ResourceTypeMap = {
  None: new ResourceTypeDetail({ id: 'None', name: 'Nincs', typename: '' }),
  DataEntry: new ResourceTypeDetail({ id: 'DataEntry', name: 'Adatszolgáltatás', typename: 'DataEntry' }),
  Organization: new ResourceTypeDetail({ id: 'Organization', name: 'Szervezet', typename: 'Organization' }),
  Assignment: new ResourceTypeDetail({ id: 'Assignment', name: 'Jogosultság', typename: 'Assignment' }),
  Profile: new ResourceTypeDetail({ id: 'Profile', name: 'Felhasználó', typename: 'Profile' }),
  ModificationRequest: new ResourceTypeDetail({ id: 'ModificationRequest', name: 'Módosítási kérelem', typename: 'ModificationRequest' }),
  ClarificationRequest: new ResourceTypeDetail({ id: 'ClarificationRequest', name: 'Adategyeztetés', typename: 'ClarificationRequest' }),
  Batch: new ResourceTypeDetail({ id: 'Batch', name: 'Tömeges művelet', typename: 'Batch' }),
  Case: new ResourceTypeDetail({ id: 'Case', name: 'Ügyfélkapcsolat', typename: 'Case' }),
  Bulletin: new ResourceTypeDetail({ id: 'Bulletin', name: 'Közlemény', typename: 'Bulletin' }),
  OfficialAct: new ResourceTypeDetail({ id: 'OfficialAct', name: 'Hivatalos cselekmény', typename: 'OfficialAct' }),
  Universal: new ResourceTypeDetail({ id: 'Universal', name: 'Nyilvántartási elem', typename: 'Universal' }),

  External: new ResourceTypeDetail({ id: 'External', name: 'Külső (rendszeren kívüli)', typename: 'External' }),
};

export const ResourceTypeList: ResourceTypeDetail[] = [
  ResourceTypeMap.None,
  ResourceTypeMap.DataEntry,
  ResourceTypeMap.Organization,
  ResourceTypeMap.Assignment,
  ResourceTypeMap.Profile,
  ResourceTypeMap.ModificationRequest,
  ResourceTypeMap.ClarificationRequest,
  ResourceTypeMap.Batch,
  ResourceTypeMap.Case,
  ResourceTypeMap.Bulletin,
  ResourceTypeMap.OfficialAct,
  ResourceTypeMap.Universal,

  ResourceTypeMap.External,
];


export class WorkflowTemplateDescriptor implements ModuleModel {
  public discriminator = 'WorkflowTemplateDescriptor';

  public id: string;
  public identifier: string;
  public version: number;
  public title: string;
  public primaryResourceTypeName: string;
  public designerId: string;
  public validFrom: Date;
  public validUntil?: Date;

  public href: string;
  public modified: Date;
  public deleted: Date;

  public fullTitle: string;
  public validFromFormatted: string;
  public validUntilFormatted: string;
  public designerInfo?: any;
  public designerDetail?: ProfileModel;
  public designerFullName?: string;

  constructor(options?: {
    id: string;
    identifier: string;
    version: number;
    title: string;
    primaryResourceTypeName: string;
    designerId: string;
    validFrom: Date;
    validUntil?: Date;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.identifier = options.identifier;
      this.version = options.version;
      this.title = options.title;
      this.primaryResourceTypeName = options.primaryResourceTypeName;
      this.designerId = options.designerId;
      this.validFrom = options.validFrom;
      this.validUntil = options.validUntil;

      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/workflow.template/model/workflow.template.ts